import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import EnterOTPLayout from "components/EnterOTPLayout";

class EnterOTPPage extends Component {
  render() {
    return (
      <div className="enter-otp-page">
        <div className="inner-content">
          <EnterOTPLayout />
        </div>
      </div>
    );
  }
}

export default withRouter(EnterOTPPage);
